import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextArea from '../../components/form/TextArea';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import STRINGS from './../../data/language/language';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Ws from '../../config/Ws';
import PAGES from '../../config/Pages';
import TextEditor from '../../components/form/TextEditor';

const URL_SAVE = WS.planos_alimentares.save;

class Page extends React.Component{
  constructor (props){
    super(props);


    const stateDefault = {
      ativo: props.detalhe ? props.detalhe.ativo : false,
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE],
      detalhe: props.detalhe
    };
    const state = {...props.detalhe, ...stateDefault};

    this.state = state;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTextMasculino = this.handleTextMasculino.bind(this);
    this.handleTextFeminino = this.handleTextFeminino.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  handleTextMasculino(value) {
    this.setState({ masculino: value });
  }

  handleTextFeminino(value) {
    this.setState({ feminino: value });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit (e){

    e.preventDefault();

    const _self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar
    }
    = this.state.strings;

    const formData = new FormData(e.target);

    //retorna todos os exercicios adicionados
    let idForm = e.target.getAttribute('id');

    const titulo = formData.get('titulo');
    const masculino = formData.get('masculino');
    const feminino = formData.get('feminino');

    if(titulo === "" || masculino === "" || feminino === ""){
      let msg = {
        title: atencao,
        text:preenchaCamposAsterisco
      };
      Dialog.create(msg);

      return false;
    }

    const object = FormDataToJson(formData);
    object.ativo = object.ativo ? 1 : 0;
    object.masculino = masculino;
    object.feminino = feminino;
    //----------------

    Requisitions({
      url:URL_SAVE,
      data: object,
      sucess:function(data){
        if(data.status){
          _self.props.modal.close();
          _self.props.history.push(PAGES.planos_alimentares);
        }

        const msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });
  }

  render (){
    const {
      titulo,
      fieldDigiteNome,
      imagem,
      planoFeminino,
      planoMasculino,
      salvar,
      cadastroPlanoAlimentar,
      linkYoutube,
      digiteAqui,
      ativar,
      observacoes
    } = this.state.strings;

    const tituloVal = this.state.titulo;
    const imagemVal = this.state.imagem;
    const linkVal = this.state.link;
    const mascVal = this.state.masculino;
    const femVal = this.state.feminino;
    const obsVall = this.state.observacoes;
    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} />   : '';

    return (
      <div>
        <MainTitle title={cadastroPlanoAlimentar}></MainTitle>
        <form id={this.state.wrapper} className="" onSubmit={this.handleSubmit}>
          {id}
          <div className="pure-u-3-5">
            <p className='box-ativar'><input value='1' onChange={this.handleInputChange} checked={this.state.ativo} type='checkbox' name='ativo' /> <span>Ativar</span></p>
          </div>
          <div className="pure-u-3-5">
            <TextInput
              value={tituloVal}
              name="titulo"
              title={titulo+"*"}
              placeholder={fieldDigiteNome}>
            </TextInput>
          </div>
          <div>
            <div className="pure-u-1-2">
              <TextInputWithUploader value={imagemVal} name="imagem" title={imagem} placeholder=""></TextInputWithUploader>
            </div>
            <div className="pure-u-1-2">
              <TextInput name="link" value={linkVal} title={linkYoutube} placeholder={digiteAqui}></TextInput>
            </div>
          </div>

          <div className="">
            <TextArea name="feminino"  value={femVal} title={planoFeminino+"*"} placeholder=""></TextArea>
          </div>
          <div className="">
            <TextArea name="masculino"  value={mascVal} title={planoMasculino+"*"} placeholder=""></TextArea>
          </div>
          <div className="">
            <TextArea name="observacoes"  value={obsVall} title={observacoes} placeholder=""></TextArea>
          </div>
          <div className="box-right-button"><Button type="submit" text={salvar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/planos-alimentares/Page.js